import React from "react";

import * as Styled from "./styles";

import { ReactComponent as MenuIcon } from "shared/assets/svg/menu.svg";
import { Avatar, Badge, Menu, MenuItem, Typography, Box, Modal, Button } from "@mui/material";
import { FaCircleInfo } from "react-icons/fa6";

/*import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";*/
import { menuPatientAvaliation } from "shared/mock";
import { DEFAULT_AVATAR } from "shared/config/properties";
import { CloseConsult } from "components/CloseConsult";
import { Documentation } from "components/Documentation";
import { ClinicalRecordUser } from "components/ClinicalRecord";
import { useAvaliation } from "shared/providers/Avaliation";
import { useAuth } from "shared/providers/auth";
import { WaitingPatients } from "components/WaitingPatients";
import { getAttendedConsultations } from "requests/Patient";
import { IAttendedConsultationsData } from "shared/types/Patient";

interface IProps {
  title: any;
  children?: any;
}

const HeadConsult: React.FC<IProps> = ({ title, children }) => {
  const { user, scheduleData } = useAuth();
  const { patientObj /*step*/ } = useAvaliation();

  const currentScheduleId = React.useMemo(() => {
    try {
      const raw = localStorage.getItem("personAttendance");
      if (raw) return JSON.parse(raw)?.id ?? null;
    } catch {}
    return null;
  }, []);

  const waitingCount = React.useMemo(() => {
    let count = 0;
    scheduleData.forEach((slot) => {
      slot.data?.forEach((item) => {
        if (
          (item.st_schedule === "C" || item.st_schedule === "T") &&
          item.inService !== 1 &&
          item.id !== currentScheduleId
        ) count++;
      });
    });
    return count;
  }, [scheduleData, currentScheduleId]);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [openClose, setOpenClose] = React.useState<boolean>(false);

  const [openCloseDocumentation, setOpenCloseDocumentation] =
    React.useState<boolean>(false);

  const [openCloseClinicalRecord, setOpenCloseClinicalRecord] =
    React.useState<boolean>(false);

  const [openPatientInfo, setOpenPatientInfo] = React.useState<boolean>(false);
  const [openWaitingPatients, setOpenWaitingPatients] = React.useState<boolean>(false);

  const [attendedConsultations, setAttendedConsultations] =
    React.useState<IAttendedConsultationsData | null>(null);

  React.useEffect(() => {
    const fetchAttendedConsultations = async () => {
      try {
        const { data, status } = await getAttendedConsultations(
          user.data.id,
          patientObj.pac_id
        );
        if ([200, 201].includes(status) && data.success) {
          setAttendedConsultations(data.data);
        }
      } catch (error) {
        console.error("Erro ao buscar consultas atendidas:", error);
      }
    };

    if (patientObj && patientObj.pac_id) {
      fetchAttendedConsultations();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientObj?.pac_id, user.data.id]);

  /* function LinearProgressWithLabel(
    props: LinearProgressProps & { value: number }
  ) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column-reverse",
          gap: "10px",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box>
          <Typography
            variant="body2"
            color="#007DED"
            sx={{ fontWeight: "500", fontSize: "18px" }}
          >
            {title}
          </Typography>
        </Box>
      </Box>
    );
  }

  function LinearWithValueLabel() {
    return (
      <Box sx={{ width: "100%" }}>
        <LinearProgressWithLabel
          value={step === 1 ? 50 : step === 2 ? 100 : 0}
        />
      </Box>
    );
  }*/

  return (
    <>
      <Styled.Box>
        <Styled.FakeBox></Styled.FakeBox>
        <Styled.Info>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Avatar
              src={
                patientObj.pac_avatar ? patientObj.pac_avatar : DEFAULT_AVATAR
              }
              sx={{ width: "55px", height: "55px" }}
              alt={patientObj.pac_name}
            />
            <Typography sx={{ color: "#919296", fontWeight: "500" }}>
              ID {patientObj.pac_id_fant}
            </Typography>
            <Typography
              sx={{ color: "#343536", fontWeight: "bold", fontSize: "20px" }}
            >
              {patientObj.pac_name && patientObj.pac_name}
            </Typography>
          </Box>
          {/*<LinearWithValueLabel /> */}
        </Styled.Info>
        <Styled.Menu>
          <button
            onClick={handleClick}
            style={{
              backgroundColor: "transparent",
              border: "none",
            }}
          >
            <Badge badgeContent={waitingCount} color="error" max={99}>
              <MenuIcon />
            </Badge>
          </button>
        </Styled.Menu>
      </Styled.Box>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem>
          <Styled.NoLink onClick={() => setOpenPatientInfo(true)}>
            <FaCircleInfo color="#053779" /> Informações do Paciente
          </Styled.NoLink>
        </MenuItem>

        {menuPatientAvaliation.map((item, index) => (
          <div key={`avl-menu-${index}`}>
            {item.href === "/DOC" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenCloseDocumentation(true)}>
                  {<item.icon />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : item.href === "/WAITING" ? (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => { setOpenWaitingPatients(true); handleClose(); }}>
                  {<item.icon color="#053779" />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            ) : (
              <MenuItem key={index}>
                <Styled.NoLink onClick={() => setOpenClose(true)}>
                  {<item.icon />} {item.text}
                </Styled.NoLink>
              </MenuItem>
            )}
          </div>
        ))}

        <Modal open={openClose} onClose={() => setOpenClose(false)}>
          <Box sx={{ backgroundColor: "white", height: "100%", width: "100%" }}>
            <CloseConsult
              close={() => setOpenClose(false)}
              idSchedule={patientObj && patientObj.id}
            />
          </Box>
        </Modal>

        <Modal
          open={openCloseDocumentation}
          onClose={() => setOpenCloseDocumentation(false)}
        >
          <Box sx={{ backgroundColor: "white", height: "100%", width: "100%" }}>
            <Documentation
              onClick={() => setOpenCloseDocumentation(false)}
              idPacientParam={patientObj && patientObj.pac_id}
            />
          </Box>
        </Modal>

        <Modal
          open={openCloseClinicalRecord}
          onClose={() => setOpenCloseClinicalRecord(false)}
        >
          <Box sx={{ backgroundColor: "white", height: "100%", width: "100%" }}>
            <ClinicalRecordUser
              onClick={() => setOpenCloseClinicalRecord(false)}
              idPacientParam={patientObj && patientObj.pac_id}
            />
          </Box>
        </Modal>

        <Modal open={openPatientInfo} onClose={() => setOpenPatientInfo(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "90%",
              maxWidth: "500px",
              bgcolor: "background.paper",
              borderRadius: "16px",
              boxShadow: 24,
              p: 0,
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                background: "linear-gradient(135deg, #042b7e 0%, #007DED 100%)",
                padding: "24px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <Avatar
                src={patientObj.pac_avatar ? patientObj.pac_avatar : DEFAULT_AVATAR}
                sx={{ width: "80px", height: "80px", border: "3px solid white" }}
                alt={patientObj.pac_name}
              />
              <Typography
                sx={{
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "20px",
                  textAlign: "center",
                }}
              >
                {patientObj.pac_name}
              </Typography>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.8)",
                  fontSize: "14px",
                }}
              >
                ID {patientObj.pac_id_fant}
              </Typography>
            </Box>

            {/* Content */}
            <Box sx={{ padding: "24px", display: "flex", flexDirection: "column", gap: "16px" }}>
              {patientObj.Name_detRel && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px",
                    backgroundColor: "#f5f7fa",
                    borderRadius: "10px",
                  }}
                >
                  <Typography sx={{ color: "#666", fontSize: "14px" }}>
                    Dentista Responsável
                  </Typography>
                  <Typography sx={{ color: "#042b7e", fontWeight: "600", fontSize: "14px" }}>
                    {patientObj.Name_detRel}
                  </Typography>
                </Box>
              )}

              {patientObj.aparelhos && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px",
                    backgroundColor: "#f5f7fa",
                    borderRadius: "10px",
                  }}
                >
                  <Typography sx={{ color: "#666", fontSize: "14px" }}>
                    Plano Contratado
                  </Typography>
                  <Typography sx={{ color: "#042b7e", fontWeight: "600", fontSize: "14px" }}>
                    {patientObj.aparelhos}
                  </Typography>
                </Box>
              )}

              {patientObj.beneficios && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px",
                    backgroundColor: "#f5f7fa",
                    borderRadius: "10px",
                  }}
                >
                  <Typography sx={{ color: "#666", fontSize: "14px" }}>
                    Benefícios
                  </Typography>
                  <Typography sx={{ color: "#042b7e", fontWeight: "600", fontSize: "14px" }}>
                    {patientObj.beneficios}
                  </Typography>
                </Box>
              )}

              {patientObj.dia_vcto && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px",
                    backgroundColor: "#f5f7fa",
                    borderRadius: "10px",
                  }}
                >
                  <Typography sx={{ color: "#666", fontSize: "14px" }}>
                    Data de Vencimento
                  </Typography>
                  <Typography sx={{ color: "#042b7e", fontWeight: "600", fontSize: "14px" }}>
                    Dia {patientObj.dia_vcto}
                  </Typography>
                </Box>
              )}

              {attendedConsultations && attendedConsultations.total_attended > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px",
                    backgroundColor: "#e8f5e9",
                    borderRadius: "10px",
                  }}
                >
                  <Typography sx={{ color: "#666", fontSize: "14px" }}>
                    Consultas Atendidas
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <Typography
                      sx={{
                        color: "#2e7d32",
                        fontWeight: "700",
                        fontSize: "16px",
                        backgroundColor: "#c8e6c9",
                        padding: "4px 12px",
                        borderRadius: "20px",
                      }}
                    >
                      {attendedConsultations.total_attended}
                    </Typography>
                    {attendedConsultations.treatment_start_formatted && (
                      <Typography sx={{ color: "#666", fontSize: "12px" }}>
                        desde {attendedConsultations.treatment_start_formatted}
                      </Typography>
                    )}
                  </Box>
                </Box>
              )}
            </Box>

            {/* Footer */}
            <Box sx={{ padding: "16px 24px", borderTop: "1px solid #eee" }}>
              <Button
                fullWidth
                variant="contained"
                onClick={() => setOpenPatientInfo(false)}
                sx={{
                  backgroundColor: "#042b7e",
                  borderRadius: "10px",
                  padding: "12px",
                  textTransform: "none",
                  fontWeight: "600",
                  "&:hover": {
                    backgroundColor: "#031d54",
                  },
                }}
              >
                Fechar
              </Button>
            </Box>
          </Box>
        </Modal>
      </Menu>

      <WaitingPatients open={openWaitingPatients} onClose={() => setOpenWaitingPatients(false)} />

      {children}
    </>
  );
};

export { HeadConsult };
